module.exports = __webpack_public_path__ + "img/Icon-PreciseAPC@2x.077c2bc9.png";